// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AttachmentsButtonMenu__container-c1d58e {
  min-width: 216px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/AttachmentsButton/AttachmentsButtonMenu/AttachmentsButtonMenu.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF","sourcesContent":[".container {\n  min-width: 216px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AttachmentsButtonMenu__container-c1d58e`
};
module.exports = ___CSS_LOADER_EXPORT___;
